
























































import Vue from 'vue'
import GqlQuery from '@/components/atoms/Gql/GqlQuery.vue'
import XPagination from '@/components/atoms/Pagination/XPagination.vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import STORE_OWNERS_QUERY from '@/graphql/partner/storeOwners.gql'
import { DocumentNode } from 'graphql'
import {
  Maybe,
  Member,
  Query,
  Store,
  StoreOwnersInput,
} from '@/types/generated/graphql'

type Data = {
  query: DocumentNode
  pagination: {
    first: number
    page: number
    totalPage: number
    caption: {
      total: number
      from?: Maybe<number>
      to?: Maybe<number>
    }
  }
}

type Methods = {
  update: (data: Query) => Member[]
  storesText: (owner: Member) => string
}

type Computed = {
  variables: { input: StoreOwnersInput; first: number; page: number }
}

type Props = {
  partnerId: string
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'OwnerTable',
  components: { GqlQuery, XPagination, XCard, XButton },
  props: {
    partnerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      query: STORE_OWNERS_QUERY,
      pagination: {
        first: 10,
        page: 1,
        totalPage: 0,
        caption: {
          total: 0,
          from: 0,
          to: 0,
        },
      },
    }
  },
  computed: {
    variables() {
      const { first, page } = this.pagination
      return { input: { partnerId: this.partnerId }, first, page }
    },
  },
  methods: {
    storesText(owner: Member): string {
      return (owner.stores as Store[]).map((s) => s.name).join(',')
    },
    update({ storeOwners }) {
      const { data, paginatorInfo } = storeOwners
      this.pagination = {
        ...this.pagination,
        page: paginatorInfo.currentPage,
        totalPage: paginatorInfo.lastPage,
        caption: {
          total: paginatorInfo.total,
          from: paginatorInfo.firstItem,
          to: paginatorInfo.lastItem,
        },
      }
      return data
    },
  },
})
